export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: Date | string; output: Date | string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: Date | string; output: Date | string; }
  YearMonth: { input: unknown; output: unknown; }
};

export type BuilderParameterInput = {
  defaultValue: Scalars['String']['input'];
  locked: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type BuilderTemplateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required if creating a new builder template */
  builderOptionId?: InputMaybe<Scalars['ID']['input']>;
  builderVisibleFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createPassword?: InputMaybe<Scalars['String']['input']>;
  /** ID of template item */
  id?: InputMaybe<Scalars['ID']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  parameters?: InputMaybe<Array<InputMaybe<BuilderParameterInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CopyBuilderTemplateInput = {
  /** Title for the copied template */
  newTitle: Scalars['String']['input'];
  /** ID of the template item to copy */
  templateItemId: Scalars['ID']['input'];
};

export type CreatedFilterInput = {
  createdGte?: InputMaybe<Scalars['DateTime']['input']>;
  createdLt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ImageTypeEnum {
  GIF = 'GIF',
  Image = 'Image',
  Video = 'Video'
}

export type LabelInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/** An enumeration. */
export enum LanguageType {
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH'
}

export enum ObjectTypeEnum {
  Content = 'Content',
  Delivery = 'Delivery',
  View = 'View'
}

/** An enumeration. */
export enum RoleType {
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  USER = 'USER'
}

export type TagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  language?: InputMaybe<LanguageType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photoBase64?: InputMaybe<Scalars['String']['input']>;
  photoFilename?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleType>;
};
